import React from 'react';
import { Alert, AlertTitle, AlertText, AlertActions, AlertDismissButton } from '@fiverr-private/feedback';
import { Link } from '@fiverr-private/typography';
import { useModerationAlert } from '@fiverr-private/portfolio/src/components/PortfolioModal';
import { articlesLinks } from '@fiverr-private/portfolio/src/components/PortfolioModal/ModerationRemovedAlert';
import pathfinder from '@fiverr-private/pathfinder';
import { AppI18n } from '../../i18n';

export const MODERATION_ALERT_LS_NAME = 'portfolio_moderation_alert_closed';

export const ModerationRemovedAlert = () => {
  const { isModerationAlertClosed, closeModerationAlert } = useModerationAlert(MODERATION_ALERT_LS_NAME);

  if (isModerationAlertClosed === undefined || isModerationAlertClosed) {
    return null;
  }

  return (
    <Alert variant="warning">
      <AlertTitle>
        <AppI18n k="removed_alert.title" />
      </AlertTitle>
      <AlertText>
        <AppI18n k="removed_alert.description" />
        <Link
          color="blue_1100"
          href={pathfinder('help_center_article', { article_id: articlesLinks.UNSPECIFIED })}
          cursor="pointer"
        >
          <AppI18n k="removed_alert.learn_more" />
        </Link>
      </AlertText>
      <AlertActions>
        <AlertDismissButton onClick={closeModerationAlert} />
      </AlertActions>
    </Alert>
  );
};
